module.exports = __webpack_public_path__ + "static/img/doudian_logo.7a2cdf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doudian_logo.png
// module id = XZmT
// module chunks = 2